import { render, staticRenderFns } from "./CommonBanner.vue?vue&type=template&id=61f31371&scoped=true"
import script from "./CommonBanner.vue?vue&type=script&lang=ts"
export * from "./CommonBanner.vue?vue&type=script&lang=ts"
import style0 from "./CommonBanner.vue?vue&type=style&index=0&id=61f31371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f31371",
  null
  
)

export default component.exports